export const DEFAULT_GROUP: any = [
  {
    key: "General",
    styles: {},
  }
]